module.exports = __webpack_public_path__ + "static/media/elixir-restaurant.673c7a6e.pdf";